import errAnnouceApi from 'api/errAnnouceApi'
import invoiceApi from 'api/invoiceApi'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import { default as ToastHelper } from 'general/helpers/ToastHelper'
import { default as Utils } from 'general/utils/Utils'

export const updateErrAnnouce = async (
  submitAction,
  tableData,
  values,
  dispatch,
  setAppSpinning,
  navigate,
  currentAccount,
  signingConfig,
  resetButtonSaveAndSign = () => {},
) => {
  const invoiceIdsArray = tableData.map((item, index) => {
    return item?.invoiceId
  })
  values.invoiceIdsArray = invoiceIdsArray

  try {
    const res = await errAnnouceApi.updateAccountingDocument({
      ...values,
      tableData,
    })
    if (res?.result === 'success') {
      ToastHelper.showSuccess('Cập nhật thông báo nháp thành công')
      // navigate('/hoa-don-dau-ra/xu-ly-hoa-don/danh-sach-thong-bao-sai-sot')
      switch (submitAction) {
        case 'Save': {
          navigate('/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-lap-sai')
          break
        }
        case 'SaveAndSign': {
          let errorAnnoucementId = values.errorAnnoucementId

          let { signingMethod } = signingConfig
          if (signingMethod == 'HSM') {
            await errAnnouceApi.hsmSignErrAnnouceDocument({
              errorAnnoucementId,
            })

            ToastHelper.showSuccess('Ký thông báo sai sót thành công')
            navigate('/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-lap-sai')
          } else {
            let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
            const urlSchema = `${process.env.REACT_APP_BASE_URL_SCHEMA}${accessToken},message300,${errorAnnoucementId},${currentAccount?.taxCode}`
            Utils.openToolSignErrAnnouce(
              urlSchema,
              accessToken,
              dispatch,
              setAppSpinning,
              navigate,
            )
          }

          break
        }
      }
    }
  } catch (err) {
    console.log(err)
  } finally {
    dispatch(setAppSpinning(false))
    resetButtonSaveAndSign(false)
  }
}
